import React from 'react';
import { MediaPlayer, PropTypes } from '..';

export function ShortMediaPlayer(props: PropTypes) {
  return <MediaPlayer {...props} className='short-video' />;
}
